import Swal from 'sweetalert2'
import {IPermissionsModel, IPermission} from '../../modules/auth/models/PermissionsModel'
import {hasPermission} from '../../modules/utils/UserPermissions '
import {IInventoryOfSupplier} from '../auth/models/InventoryOfSupplierModel'
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import moment from 'moment';
import _ from 'lodash';
import { IOrder, IOrderProduct } from '../../models/OrderModel';
import { ReceiptDetailModel } from '../../models/ReceiptDetailModel';
import * as XLSX from 'xlsx';
import qz from '../../../setup/qz/qzSecurity';
import { LOCAL_PRINTER_KEY } from '../../constants/common';

export const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast: any) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  },
})

export const Confirm = Swal.mixin({
  position: 'center',
  showConfirmButton: true,
  showCancelButton: true,
})

export const ToastConfirm = Swal.mixin({
  toast: true,
  position: 'center',
  showConfirmButton: true,
})

export const download = (data: Blob, name: string, format: string = 'xlsx') => {
  let url = ''
  if (data instanceof Blob) {
    url = URL.createObjectURL(data)
  } else {
    url = URL.createObjectURL(new Blob([data]))
  }
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', `${name}.${format}`)
  document.body.appendChild(link)
  link.click()

  setTimeout(() => {
    link.removeAttribute('href')
    link.removeAttribute('download')
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
  }, 100)
}

export const checkPermissions = (userPermissions: IPermission[]): IPermissionsModel => {
  return {
    canView: hasPermission(userPermissions, 'view'),
    canCreate: hasPermission(userPermissions, 'create'),
    canUpdate: hasPermission(userPermissions, 'update'),
    canDelete: hasPermission(userPermissions, 'delete'),
  }
}

export const roundNumber = (number: number, decimals: number = 0) => {
  // if (isNaN(number)) {
  //   return 0
  // }
  const factor = Math.pow(10, decimals)
  return Math.round(number * factor) / factor
}

export const getBestSupplier = (inventoryOfSupplier: Array<IInventoryOfSupplier>) => {
  return inventoryOfSupplier.reduce((result: any, item: IInventoryOfSupplier) => {
    let minPrice = result.length ? result[0].price_sell : item.price_sell
    let priceSell = item?.price_sell ?? 0
    if (priceSell < minPrice) {
      minPrice = item.price_sell
      result.length = 0
    }

    if (item.price_sell === minPrice) {
      result = {...item}
    }

    return result
  }, {})
}

export const convertDotNotationToObject = (dotNotationObj: {[key: string]: any}) => {
  const resultObj = {}

  Object.keys(dotNotationObj).forEach((key) => {
    const value = dotNotationObj[key]
    const keyParts = key.split('.')
    let currentPart: {[key: string]: any} = resultObj

    for (let i = 0; i < keyParts.length - 1; i++) {
      const part = keyParts[i]
      if (!currentPart[part]) currentPart[part] = {}
      currentPart = currentPart[part]
    }

    currentPart[keyParts[keyParts.length - 1]] = value
  })

  return resultObj
}

export const getDiscount = (price: number, supplierPrice: number) => {
  let discount = 0
  if (price !== 0 || supplierPrice !== 0) {
    discount = price - supplierPrice
  }
  return roundNumber((discount / price) * 100, 2) >= 0
    ? roundNumber((discount / price) * 100, 2)
    : 0
}

export const htmlToCanvas = async (htmlContent: any, name: string, format: string) => {
    const container = document.createElement("div");
    container.style.position = "fixed";
    container.style.width = "80mm";
    container.style.left = "-9999px"; // keep off-screen
    container.innerHTML = htmlContent;
    document.body.appendChild(container);
    
    // Convert HTML to canvas
    const canvas = await html2canvas(container, { scale: 4 });
    const imgData = canvas.toDataURL("image/png");
  
    // PDF size: 80mm width, dynamic height
    const pdfWidth = 80; // mm
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
    let formatSize: any = 'a4';
    if (format === 'tp80') {
      formatSize = [pdfWidth, pdfHeight];
    }
    const pdf = new jsPDF("p", "mm", formatSize);
    pdf.addImage(imgData, "JPEG", 0, 0, pdfWidth, pdfHeight);
    pdf.save(`${name}.pdf`);
    setTimeout(() => {
      document.body.removeChild(container);
    }, 100)
};

export const qrPdf = async (htmlContent: any, name: string, format: string) => {
  // Tạo container 80mm
  const container = document.createElement("div");
  container.style.position = "fixed";
  container.style.width = "80mm";
  container.style.left = "-9999px"; // keep off-screen
  container.innerHTML = htmlContent;
  document.body.appendChild(container);

  // Chụp thành canvas
  const canvas = await html2canvas(container, { scale: 2, useCORS: true });

  const pdfWidth = 80; // mm
  const pdfPageHeight = 100; // mm mỗi trang (có thể chỉnh dài hơn)
  const pdf = new jsPDF("p", "mm", [pdfWidth, pdfPageHeight]);

  // Quy đổi mm → pixel
  const pageHeightPx = (canvas.width * pdfPageHeight) / pdfWidth;
  let position = 0;
  while (position < canvas.height) {
    // Tạo canvas cho từng phần trang
    const pageCanvas = document.createElement("canvas");
    pageCanvas.width = canvas.width;
    pageCanvas.height = Math.min(pageHeightPx, canvas.height - position);

    const ctx = pageCanvas.getContext("2d");
    ctx?.drawImage(
      canvas,
      0,
      position,
      canvas.width,
      pageCanvas.height,
      0,
      0,
      canvas.width,
      pageCanvas.height
    );

    const pageImgData = pageCanvas.toDataURL("image/png");
    const pageHeightMM = (pageCanvas.height * pdfWidth) / canvas.width;

    if (position === 0) {
      pdf.addImage(pageImgData, "PNG", 0, 1, pdfWidth, pageHeightMM);
    } else {
      pdf.addPage([pdfWidth, pdfPageHeight]);
      pdf.addImage(pageImgData, "PNG", 0, 1, pdfWidth, pageHeightMM);
    }
    position += pageHeightPx;
  }

  pdf.save(`${name}.pdf`);
  setTimeout(() => {
    document.body.removeChild(container);
  }, 100)
};

export const isMoreThanHoursAgo = (inputDatetime: string | undefined, hours: number) => {
  if (!inputDatetime) {
    return false
  }
  return moment().subtract(hours, 'hours').isAfter(inputDatetime)
}

export const hasDuplicates = (arr: any[]) => {
  return _.uniq(arr).length !== arr.length; 
}

export const getDefaultPriceAgency = (product: IOrderProduct) => {
    return {
        price: product.price,
        market_price: product.price,
        discount: 0
    }
}

export const countWorkingDays = (year: number, month: number) => {
  let count = 0
  const startOfMonth = moment({ year, month }).startOf('month')
  const endOfMonth   = moment({ year, month }).endOf('month')

  const current = startOfMonth.clone()

  while (current.isSameOrBefore(endOfMonth, 'day')) {
    const dayOfWeek = current.day() // 0 = CN, 6 = T7

    // if (dayOfWeek !== 0 && dayOfWeek !== 6) {
      count++
    // }

    current.add(1, 'day')
  }
  return count
}

export const calcSocialInsurance = (salary: number) => {
  return 0;
}

export const isShowConsignment = () => {
  return process.env.CONSIGNMENT_ENABLED;
}

export const isPartPaid = (item: IOrder) => {
  let cashAmount = item.cash_amount ?? 0;
  let bankAmount = item.bank_amount ?? 0;
  return (
    String(item.payment_status) === '1'
    && cashAmount + bankAmount < item.total_price
  ) 
}
export const checkEAN13 = (code: string): boolean => {
  const digits = code.split('').map(Number);

  const sum = digits
    .slice(0, 12)
    .reduce((acc, num, idx) => {
      return acc + num * (idx % 2 === 0 ? 1 : 3);
    }, 0);

  const checkDigit = (10 - (sum % 10)) % 10;

  return checkDigit === digits[12];
};

export const checkEAN8 = (code: string): boolean => {
  const digits = code.split('').map(Number);

  const sum = digits
    .slice(0, 7)
    .reduce((acc, num, idx) => {
      return acc + num * (idx % 2 === 0 ? 3 : 1);
    }, 0);

  const checkDigit = (10 - (sum % 10)) % 10;

  return checkDigit === digits[7];
};

export const checkUPC = (code: string): boolean => {
  const digits = code.split('').map(Number);

  const sum = digits
    .slice(0, 11)
    .reduce((acc, num, idx) => {
      return acc + num * (idx % 2 === 0 ? 3 : 1);
    }, 0);

  const checkDigit = (10 - (sum % 10)) % 10;

  return checkDigit === digits[11];
};

export const isValidBarcode = (code: string): boolean => {
  if (!code) return false;
  code = code.trim();
  

  // Chỉ cho phép ký tự phổ biến của barcode
  if (!/^[0-9A-Z\-.]+$/.test(code)) return false;

  // Check mã EAN-13 (Quy định của VN)
  return checkEAN13(code);

  // Từ đây trở xuống là backup
  // Kiểm tra EAN-13
  if (/^\d{13}$/.test(code)) {
    return checkEAN13(code);
  }

  // Kiểm tra EAN-8
  if (/^\d{8}$/.test(code)) {
    return checkEAN8(code);
  }

  // Kiểm tra UPC-A (12 số)
  if (/^\d{12}$/.test(code)) {
    return checkUPC(code);
  }

  // Kiểm tra CODE-128 / CODE-39 
  if (/^[0-9A-Z\-.]{4,}$/.test(code)) {
    return true;
  }

  return false;
};

export const generateProductCode = (name: string) => {
  if (!name) return '';
  name = name.normalize("NFD")?.replace(/[\u0300-\u036f]/g, "")?.replace(/[đĐ]/g, m => m === 'đ' ? 'd' : 'D').toUpperCase();
  let initials = name.split(/\s+/)
    .map(word => word[0] || '')
    .join('');


  let upper = initials.toUpperCase();
  if (upper.length < 2) {
    upper = name.substring(0, 2).toUpperCase();
  }
  upper = upper.substring(0, 7);

  const pairs = upper.match(/.{1,2}/g);

  return pairs?.join('-') || '';

}

export const getPdCost = (
  item: IOrderProduct, 
  isGetWarehouse: boolean,
  receiptDetails: ReceiptDetailModel[]
) => {
  const product = item.replaced_by ? {
    ...item.replaced_by,
    inventory_of_sento_id: item.replaced_by.id
  } : item;
  let bestSupplier: IInventoryOfSupplier = product.best_supplier ?? {};
  const iSuppliers = product.inventory_of_suppliers ?? product.inventory_of_supplier
  let IOfSup = _.find(iSuppliers, function(o) { return o.id == bestSupplier.id; });
  let warehouse = IOfSup?.warehouse ?? undefined;

  // Giá vốn = giá ncc tốt nhất
  var costPrice = bestSupplier?.price || IOfSup?.price;
  // VAT vốn =
  let costVat = warehouse?.vat ?? (item.vat ?? 0);

  // Nếu Lấy từ kho => giá vốn = giá kho & vat vốn = vat trong kho
  if (isGetWarehouse && warehouse && warehouse?.quantity > 0) {
    costPrice = warehouse.origin_price
    costVat = warehouse.vat ?? costVat
  }

  // Nếu đơn đã duyệt => giá vốn = giá đã xuất & vat vốn = vat đã xuất hàng
  if (receiptDetails && receiptDetails.length > 0) {
    let rcDetail: any = _.find(receiptDetails, {order_id: item.order_id, inventory_of_sento_id: product.inventory_of_sento_id});
    if (rcDetail) {
      costPrice = rcDetail?.price ?? 0;
      costVat = rcDetail?.vat ?? item.vat;
    }
  }

  return (costPrice ?? item.price) * (1 + costVat/100);
}

export const getPdPrice = (
  item: IOrderProduct
) => {
  const priceOfAgency = item.price_of_agency ?? {};
  return priceOfAgency?.new_sale_price ?? priceOfAgency?.sale_price ?? item.price;
}

export const isValidDate = (dateStr: string) => {

  // dd/mm/yyyy
  const regex = /^\d{2}\/\d{2}\/\d{4}$/;
  if (!regex.test(dateStr)) return false;

  const [d, m, y] = dateStr.split('/').map(Number);
  const date = new Date(y, m - 1, d);

  return (
    date.getFullYear() === y &&
    date.getMonth() === m - 1 &&
    date.getDate() === d
  );
}

export const parseInvoice = (invoice: string): [string | null, string | null, string | null] => {
  const match = invoice.match(/^(\d)?([A-Z0-9]{6})(\d+)$/);
  if (match) {
    return [
      match[1] || null, // Ký hiệu mẫu số
      match[2] || null, // Ký hiệu HĐ
      match[3] || null, // Số HĐ
    ];
  }
  return [null, null, null];
};

export const isValidInvoiceSymbol = (value: string): boolean => {
  const regex = /^([A-Z0-9]{6})$/;
  return regex.test(value);
};
export const isValidInvoiceTemplate = (value: string): boolean => {
  const regex = /^\d+$/; 
  return regex.test(value);
};

export const isValidInvoiceNo = (value: string): boolean => {
  const regex = /^\d+$/; 
  return regex.test(value);
};

export const isValidinvoice = (invoice: string) => {
  if (!/^\d/.test(invoice)) {
    invoice =  '1' + invoice;
  }
  let parse = parseInvoice(invoice);
  return !parse.every(v => v === null);
}

export const getVersion = () => {
  return process.env.REACT_APP_BUILD_VERSION || 'latest';
}

export const removeTrailingZeros = (value: number | string): number  => {
    return Number(value);
}



export const checkValidTemplate = async (
  file: File,
  templateHeader: string[],
  headerRow: number = 0
): Promise<boolean> => {
  try {
    const buffer = await file.arrayBuffer();

    const workbook = XLSX.read(buffer, {
      type: 'array',
    });

    const worksheet = workbook.Sheets[workbook.SheetNames[0]];

    if (!worksheet) return false;

    const normalize = (value: unknown) =>
      String(value)
        .trim()
        .toLowerCase()
        .replace(/\s+/g, ' ');

    const headers = new Set<string>();

    const range = XLSX.utils.decode_range(worksheet['!ref'] || '');

    // Chỉ đọc các cell ở dòng headerRow
    for (let col = range.s.c; col <= range.e.c; col++) {
      const cell = worksheet[
        XLSX.utils.encode_cell({
          r: headerRow,
          c: col,
        })
      ];
      if (cell?.v != null) {
        headers.add(normalize(cell.v));
      }
    }
    
    return templateHeader.every((header) =>
      headers.has(normalize(header))
    );
  } catch {
    return false;
  }
};

export const isMobile = () => {
  return window.matchMedia('(max-width: 768px)').matches;
}

export const getCurrentPrinterName = () => {
  return localStorage.getItem(LOCAL_PRINTER_KEY) ?? 'XP-80C';
}

export const setPrinter = (name: string) => {
    localStorage.setItem(LOCAL_PRINTER_KEY, name)
}

export const getPrintersStatus = async (printer: string) => {
  try {
    await qz.printers.startListening(printer)
    return await qz.printers.getStatus()
  } catch (e) {
    console.error('Lỗi kiểm tra trạng thái máy in:', e)
    return null
  }
}

export const isOnlinePrinter = async (printer: string) => {
  return true;
  const status = await getPrintersStatus(printer)
  if (!status) return false

  return true
}


export const qzPrinter = async (html: string) => {
  if (!html || typeof html !== 'string') {
        throw new Error('Dữ liệu in hợp lệ')
      }

      // Kết nối QZ Tray
      if (!qz.websocket.isActive()) {
        await qz.websocket.connect()
      }

      // Tìm máy in TP80
      const printers = await qz.printers.find(getCurrentPrinterName());
      
      const printer = Array.isArray(printers)
        ? printers[0]
        : printers;

      const printerIsOnline = await isOnlinePrinter(printer);

      if (!printer || !printerIsOnline) {
        throw new Error('Không tìm thấy máy in');
      }

      // Cấu hình máy in
      const config = qz.configs.create(printer, {
        encoding: 'UTF-8',
        margins: {
          top: 0,
          left: 0,
          right: 0,
          bottom: 0
        },
        units: 'mm',
        scaleContent: true,
        jobName: 'Sento POS - Hoa don',
      })

      await qz.print(config, [
        {
          type: 'pixel',
          format: 'html',
          flavor: 'plain',
          data: html
        },
      ])
}

export const printHandler = async (data: any, fileName: string = '', format: string = 'tp80') => {
  if (!isMobile()) {
    try {
      await qzPrinter(data)
    } catch (err: any) {
      Toast.fire({
        title: 'Không thể kết nối máy in',
        icon: 'error'
      })
    }
    return;
  }

  htmlToCanvas(data, fileName, format)
}



